var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNamuChef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16058 17.009L17.9996 17M11.9996 3C13.9176 3 15.5196 4.35 15.9096 6.151C16.4167 6.01377 16.9458 5.97776 17.4669 6.04503C17.9879 6.11231 18.4905 6.28154 18.9461 6.54308C19.4018 6.80462 19.8014 7.15333 20.1222 7.56931C20.4431 7.9853 20.6789 8.4604 20.8161 8.9675C20.9533 9.4746 20.9893 10.0038 20.922 10.5248C20.8548 11.0458 20.6855 11.5485 20.424 12.0041C20.1625 12.4597 19.8138 12.8593 19.3978 13.1802C18.9818 13.501 18.5067 13.7368 17.9996 13.874V21H5.99958V13.874C5.49249 13.7366 5.01741 13.5007 4.60147 13.1798C4.18554 12.8588 3.8369 12.4591 3.57546 12.0034C3.31401 11.5477 3.14489 11.0449 3.07774 10.5239C3.01058 10.0028 3.04672 9.4736 3.18408 8.9665C3.32145 8.4594 3.55735 7.98432 3.87831 7.56839C4.19928 7.15246 4.59902 6.80382 5.05473 6.54237C5.51043 6.28093 6.01317 6.1118 6.53423 6.04465C7.0553 5.9775 7.58448 6.01364 8.09158 6.151C8.28542 5.25857 8.7788 4.45933 9.48973 3.88611C10.2007 3.31289 11.0863 3.0002 11.9996 3Z",
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamuChef);
export default __webpack_public_path__ + "static/media/Namu Chef.45f7f2418789ec3632f26e24120807af.svg";
export { ForwardRef as ReactComponent };